import { render, staticRenderFns } from "./YeastarCloudPbxLinkToTask.vue?vue&type=template&id=d85dafd8&scoped=true"
import script from "./YeastarCloudPbxLinkToTask.vue?vue&type=script&lang=js"
export * from "./YeastarCloudPbxLinkToTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d85dafd8",
  null
  
)

export default component.exports